/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unused-vars */

import ChatPro, { IAppContext } from '@byted-cg/linkchat-core';
import { MESSAGE_ALL_TYPE } from '../constants/index';

import { AnyAsyncFunction, CombineMessageType } from '../lib/type';
/**
 * ToDo:
 * 1. How to asynchronously return configuration, such as utils, jsBridge, theme, etc
 */

const initPageTime = Date.now();
const jarvisMiddle = async (ctx: any, next: AnyAsyncFunction) => {
  const { message } = ctx;
  if (message.createdAt?.getTime?.() >= initPageTime) {
    message.isNew = true;
  }
  try {
    if (
      Number(message.type) === MESSAGE_ALL_TYPE.JARVIS_TYPE &&
      message.content
    ) {
      const content = JSON.parse(message.content);
      const componentMeta = JSON.parse(content.componentMeta);

      const componentConfig = JSON.parse(content.componentConfig);

      const { name, version } = componentMeta;
      const info = name.replace(/@/g, '');
      const assetsPrefix = '//unpkg.byted-static.com';

      ctx.message.component = {
        code: componentMeta.componentCode,
        version,
        isRemote: true,
        meta: componentMeta,
        config: componentConfig,
        component: {
          js: `${assetsPrefix}/${info}/${version}/lib/index.js`,
          css: `${assetsPrefix}/${info}/${version}/lib/index.css`,
        },
      };

      // Floating card, hide profile photo
      if (componentMeta.componentType === 'fixed-card') {
        if (ctx.message.user) {
          ctx.message.user.avatar = null;
        }
      }

      if (ctx.message?.ext?.jarvis_data) {
        try {
          ctx.message.jarvisData = JSON.parse(ctx.message?.ext?.jarvis_data);
        } catch (error) {
          ctx.message.jarvisData = {};
        }
      }

      try {
        const cdn = JSON.parse(content.cdn);
        ctx.message.component.component = {
          js: `//${cdn.cn.js}`,
          css: `//${cdn.cn.css}`,
        };
      } catch (e) {
        //
      }
    }
  } catch (error) {}
  ctx.message.handledByJarvis = true;
  await next();
};

/**
 * The plugin is in the form of ProSDK's extended capabilities
 * Its API remains consistent with ProSDK
 */
export default class JarvisPlugin {
  // Plugin name, hump name
  private name = 'jarvisPlugin';

  /**
   * @param {Object} Configuration of config  plugin
   */
  constructor() {}

  /**
   * Plugin initialization method
   * @param app application instance
   * @param ctx application context
   */
  apply(app: ChatPro, ctx: IAppContext<CombineMessageType>) {
    // [Optional] Mount the plugin on ctx
    app.addSingleton(this.name, this);
  }

  /**
   * Life cycle
   */
  get lifecycle() {
    return {
      messageChange: async (ctx: IAppContext, message: any) => {
        message.isNew = true;
      },
    };
  }

  /**
   * Layout information
   */
  get layout() {
    return {};
  }

  /**
   * Tool function
   */
  get utils() {
    return {};
  }

  /**
   * JS Bridge
   */
  get jsBridge() {
    return {};
  }

  /**
   * Theme
   */
  get theme() {
    return {};
  }

  /**
   * Middleware
   */
  get middleware() {
    return {
      receive: [jarvisMiddle],
      send: [],
    };
  }

  /**
   * Custom function
   */
  customFunction() {}
}
